import { render } from "./ShowPresentation.vue?vue&type=template&id=37df9c1c&scoped=true"
import script from "./ShowPresentation.vue?vue&type=script&lang=js"
export * from "./ShowPresentation.vue?vue&type=script&lang=js"

import "./ShowPresentation.vue?vue&type=style&index=0&id=37df9c1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37df9c1c"]])

export default __exports__